import { render, staticRenderFns } from "./SyncWithList.vue?vue&type=template&id=1db3f254&scoped=true"
import script from "./SyncWithList.vue?vue&type=script&lang=js"
export * from "./SyncWithList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db3f254",
  null
  
)

export default component.exports